export default __webpack_public_path__ + "static/media/gallery-button-right.b1f0795d.svg";